<template>
  <div class="w-full h-full text-white p-10px">
    <el-row type="flex" align="middle" class="mb-5px">
      <el-col :span="5" class="text-12px">计划名称</el-col>
      <el-col :span="19">
        <el-select
          size="small"
          class="w-full"
          popper-class="visualization-select-popper"
          v-model="progressId"
          @change="changePlan"
          placeholder="请选择计划"
        >
          <el-option
            v-for="item in planDataList"
            :key="item.id"
            :label="item.name"
            :value="JSON.stringify(item)"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" class="mb-5px">
      <el-col :span="5" class="text-12px">开始日期</el-col>
      <el-col :span="19">
        <el-date-picker
          size="small"
          :disabled="!modelLoaded"
          popper-class="visualization-picker-popper"
          style="width:100%"
          v-model="filterPlan.dateRange[0]"
          :picker-options="datePickOption"
          type="date"
          placeholder="开始日期"
        ></el-date-picker
      ></el-col>
    </el-row>
    <el-row type="flex" align="middle" class="mb-5px">
      <el-col :span="5" class="text-12px">结束日期</el-col>
      <el-col :span="19">
        <el-date-picker
          size="small"
          :disabled="!modelLoaded"
          popper-class="visualization-picker-popper"
          style="width:100%"
          v-model="filterPlan.dateRange[1]"
          :picker-options="datePickOption"
          @change="handleChangePlan"
          type="date"
          placeholder="结束日期"
        ></el-date-picker
      ></el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="5" class="text-12px">查看日期</el-col>
      <el-col :span="19">
        <el-date-picker
          size="small"
          :disabled="!modelLoaded"
          popper-class="visualization-picker-popper"
          style="width:100%"
          v-model="filterPlan.checkDate"
          :picker-options="datePickOption"
          type="date"
          placeholder="查看日期"
          @change="handleCheck"
        ></el-date-picker
      ></el-col>
    </el-row>
    <div class="h-[calc(100%-162px)] mt-10px">
      <div v-if="showProcess">
        <div class="flex items-center">
          <el-button-group>
            <el-button type="primary" :loading="btnLoading" size="small" @click="minusSpeed">
              <i class="iconfont icon-bg-backward text-12px"></i>
            </el-button>
            <el-button type="primary" size="small" :loading="btnLoading" @click="btnPlay">
              <i class="iconfont icon-bg-pause text-12px" v-if="isPlaying"></i>
              <i class="iconfont icon-bg-play text-12px" v-else></i>
            </el-button>
            <el-button type="primary" :loading="btnLoading" size="small" @click="stopPlay">
              <i class="iconfont icon-bg-stop text-12px"></i>
            </el-button>
            <el-button type="primary" :loading="btnLoading" size="small" @click="addSpeed">
              <i class="iconfont icon-bg-forward text-12px"></i>
            </el-button>
          </el-button-group>
          <span class="ml-10px">{{ speedModes[currentSpeed] }}X</span>
        </div>
        <div class="w-full">
          <el-slider
            :disabled="btnLoading"
            @change="sliderChanged"
            :show-tooltip="false"
            :min="1"
            :max="sliderMaxLenngth"
            v-model="sliderData"
          ></el-slider>
        </div>
      </div>
      <div
        class="h-[calc(100%-85px)]"
        v-if="(currentProcess && currentProcess.currentDate) || sliderLoading"
        v-loading="sliderLoading"
      >
        <div>
          <h2 class="text-20px mb-5px">
            {{
              currentProcess && currentProcess.currentDate
                ? dayjs(currentProcess.currentDate).format('YYYY/MM/DD')
                : ''
            }}
          </h2>
          <div
            v-for="(item, index) in highLightData"
            :key="index"
            class="flex items-center pt-5px pb-5px"
            :style="{ color: item.color }"
          >
            <i
              class="w-12px h-12px rounded-6px block mr-5px"
              :style="{
                backgroundColor: item.color,
              }"
            ></i>
            <span class="text-12px">{{ item.name }} :</span>
            <span class="text-12px">
              <template v-if="index === 0">
                {{ !_.isEmpty(currentShowNum) ? currentShowNum.workAsPlan : 0 }}
              </template>
              <template v-if="index === 1">
                {{ !_.isEmpty(currentShowNum) ? currentShowNum.workDelayPlan : 0 }}
              </template>
              <template v-if="index === 2">{{
                !_.isEmpty(currentShowNum) ? currentShowNum.workDelayDone : 0
              }}</template>
              <template v-if="index === 3">{{
                !_.isEmpty(currentShowNum) ? currentShowNum.delayPlanStart : 0
              }}</template>
              <template v-if="index === 4">{{
                !_.isEmpty(currentShowNum) ? currentShowNum.noWork : 0
              }}</template>
              <template v-if="index === 5">{{
                !_.isEmpty(currentShowNum) ? currentShowNum.alreadyDone : 0
              }}</template>

              <template v-if="index === 6">{{
                !_.isEmpty(currentShowNum) ? currentShowNum.notInRange : 0
              }}</template>
              <span class="text-12px">个</span>
            </span>
          </div>
        </div>
        <div
          v-if="
            currentProcess &&
              currentProcess.currentImplementTree &&
              currentProcess.currentImplementTree.length &&
              !showTaskDetail
          "
          class="h-[60%] pt-10px"
        >
          <h3 class="mb-10px font-semibold text-14px">今日任务</h3>
          <div class="h-[calc(100%-24px)] overflow-y-auto">
            <div v-for="(i, index) in currentProcess.currentImplementTree" :key="index">
              <div class="text-14px text-blue-500 cursor-pointer">
                {{ i.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from '../../service/ActivityService'
import { isJSONObj } from '../../assets/js/scene/scene'

export default {
  name: 'ProcessSimulate',
  props: {
    player: {
      type: Object,
      default: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    loadModelStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterPlan: {
        dateRange: [],
        checkDate: '',
      },
      progressId: '',
      planDataList: [],
      planStartDate: '',
      planFinishDate: '',
      btnLoading: false,
      isPlaying: false,
      showProcess: true,
      speedModes: [1, 3, 7],
      currentSpeed: 0,
      sliderData: 0,
      currentProcess: {},
      sliderLoading: false,
      currentShowNum: {},
      highLightData: [
        {
          name: '正在施工（按计划施工）',
          color: '#67C23A',
        },
        {
          name: '正在施工（落后计划开始）',
          color: '#9A32CD',
        },
        {
          name: '正在施工（落后计划结束）',
          color: '#FFFF00',
        },
        {
          name: '未施工（落后计划开始）',
          color: '#F56C6C',
        },
        {
          name: '未施工（按计划未施工）',
          color: '#409EFF',
        },
        {
          name: '已完成施工',
          color: '#1890ff',
        },
        {
          name: '不在施工进度时间范围内',
          color: '#ebeef5',
        },
      ],
      colorCollection: {
        milestonTotal: '#ffff38',
        otherTotal: '#ff8e24',
        advance: '#ff23d1',
        constructed: '#1890ff',
        workInProgress: '#67C23A',
        delayedUnfinished: '#FFFF00',
        delayedStart: '#9A32CD',
        norMalNonConstruction: '#ffffff',
        delayedConstruction: '#F56C6C',
        notInDateRange: '#ebeef5',
      },
      highLightColorNumbers: {},
      mainTimer: null,
      sliderLoadingTimer: null,
      handleCheckLoadingTimer: null,
      planModelInfo: [],
      modelLoaded: false,
      processCodeByItem: {},
      includesListData: [],
      currentUseModels: [],
      showNum: [],
      currentHighLightData: [],
      currentTiming: 0,
      changeProcessMap: {},
      processList: ['advance', 'milestonLag', 'otherLag', 'currentFinish'],
      processMap: null, // 进度模拟实际需要变化的map
    }
  },
  watch: {
    async modelLoaded(val) {
      if (val) {
        const modelsInfo = await this.player.Native.Model.getAllInfo()
        const currentItems = _.map(_.values(modelsInfo), (el) => {
          return el.treeItem
        })
        if (currentItems.length) {
          this.player.Native.ModelTree.setItemColor(currentItems, 0xffffff80)
        }
        if (this.btnPlayLoading) {
          this.btnPlay()
        }
      }
    },
    currentTiming() {
      const toTodayData = _.slice(this.includesListData, 0, this.currentTiming)
      if (this.currentTiming >= this.currentUseModels.length) {
        this.currentProcess = _.last(this.currentUseModels)
        this.sliderData = this.currentUseModels.length
        this.isPlaying = false
        clearInterval(this.mainTimer)
      }
      const currentDate = moment(this.currentProcess.currentDate).format('YYYY-MM-DD')
      this.currentShowNum = _.find(this.showNum, { dateTime: currentDate })
      this.currentHighLightData = {
        data: toTodayData,
        day: this.currentTiming,
      }
    },
    currentHighLightData: {
      async handler(newData, oldData) {
        if (!_.isEmpty(newData)) {
          const startDay = !_.isEmpty(oldData) ? oldData.day : 0
          this.processMap = new Map()
          // 判断是否倒放
          if (startDay <= newData.day) {
            // 正向播放时
            this.getChangedList(startDay, newData.day, newData.data)
            this.processMap = _.cloneDeep(this.changeProcessMap)
          } else {
            const modelsInfo = await this.player.Native.Model.getAllInfo()
            const currentItems = _.map(_.values(modelsInfo), (el) => {
              return el.treeItem
            })
            if (currentItems.length) {
              this.player.Native.ModelTree.setItemColor(currentItems, 0xffffff80)
            }
            // 倒放时
            const oldStatus = _.cloneDeep(this.changeProcessMap)
            this.getChangedList(0, newData.day, newData.data)
            this.processMap = Object.assign(this.changeProcessMap)
            if (!_.isNil(oldStatus)) {
              // eslint-disable-next-line no-restricted-syntax
              for (const item of oldStatus.entries()) {
                const k = item[0]
                const v = item[1]
                const temp = this.processMap.get(k)
                if (temp === v) {
                  this.processMap.delete(k)
                }
              }
            }
          }
          // 模型变化颜色
          await this.sumbitEngineChanges(this.processMap)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 进度条最大长度
    sliderMaxLenngth() {
      if (
        this.filterPlan.dateRange[0] &&
        this.filterPlan.dateRange[1] &&
        moment(this.filterPlan.dateRange[0]).isBefore(this.filterPlan.dateRange[1])
      ) {
        return (
          moment(this.filterPlan.dateRange[1]).diff(moment(this.filterPlan.dateRange[0]), 'day') + 1
        )
      }
      return 1
    },
    // 时间允许选择范围
    datePickOption() {
      return {
        disabledDate: (time) => {
          if (this.planStartDate && this.planFinishDate) {
            return (
              time.getTime() < moment(this.planStartDate).valueOf() ||
              time.getTime() > moment(this.planFinishDate).valueOf()
            )
          }
          return true
        },
      }
    },
  },
  async created() {
    this.getPlanList()
    this.highLightColorNumbers = this.colorCollection
    // 处理颜色格式
    _.forEach(Object.keys(this.highLightColorNumbers), (key) => {
      if (!_.isEmpty(this.highLightColorNumbers[key])) {
        this.highLightColorNumbers[key] = this.highLightColorNumbers[key].replace('#', '0x')
        // 透明度添加 未施工透明度不一致
        if (key === 'notStart' || key === 'norMalNonConstruction') {
          this.highLightColorNumbers[key] += '20'
        } else {
          this.highLightColorNumbers[key] += 'ff'
        }
        this.highLightColorNumbers[key] = Number(this.highLightColorNumbers[key])
      }
    })
    const modelsInfo = await this.player.Native.Model.getAllInfo()
    const currentItems = _.map(_.values(modelsInfo), (el) => {
      return el.treeItem
    })
    if (currentItems.length) {
      this.player.Native.ModelTree.setItemColor(currentItems, 0xffffff80)
      this.getCodeByItem()
    }
  },
  async destroyed() {
    this.stopPlay()
    this.player.Native.ModelTree.restoreAllItemColor()
    clearInterval(this.mainTimer)
  },
  methods: {
    // 处理进度模拟变化的列表
    getChangedList(start, end, data) {
      this.changeProcessMap = new Map()
      for (let i = start; i < end; i += 1) {
        const dayData = data[i]
        if (dayData) {
          // eslint-disable-next-line no-loop-func
          _.forEach(dayData, (v, k) => {
            const lastList = _.isNil(this.changeProcessMap.get(k))
              ? []
              : this.changeProcessMap.get(k)
            if (_.isNil(v)) {
              this.changeProcessMap.set(k, [])
            } else if (!_.isEmpty(v)) {
              // 判断是否为特殊list
              if (this.processList.indexOf(k) !== -1) {
                const temp = _.uniq([...v, ...lastList])
                this.changeProcessMap.set(k, temp)
              } else {
                this.changeProcessMap.set(k, v)
              }
            } else {
              this.changeProcessMap.set(k, lastList)
            }
          })
        }
      }
    },
    // 通知模型变色
    async sumbitEngineChanges(changeMap) {
      // eslint-disable-next-line no-restricted-syntax
      for (const item of changeMap.entries()) {
        const key = item[0]
        const value = item[1]
        // 获取item
        const itemList = []
        if (!_.isEmpty(value) && key !== 'norMalNonConstruction' && key !== 'notInDateRange') {
          for (let index = 0; index < value.length; index += 1) {
            const element = value[index]
            if (this.processCodeByItem[element]) {
              itemList.push(this.processCodeByItem[element])
            }
          }
          const flagLength = 4000
          if (itemList.length > flagLength) {
            const loopNum = Math.ceil(itemList.length / flagLength)
            for (let i = 0; i < loopNum; i += 1) {
              const el = itemList.slice(i * flagLength, (i + 1) * flagLength)
              if (el.length) {
                // eslint-disable-next-line no-await-in-loop
                await this.player.Native.ModelTree.setItemColor(el, this.highLightColorNumbers[key])
              }
            }
          } else if (itemList.length) {
            // eslint-disable-next-line no-await-in-loop
            await this.player.Native.ModelTree.setItemColor(
              itemList,
              this.highLightColorNumbers[key]
            )
          }
        }
      }
    },
    // 获取计划数据
    async getPlanList() {
      const [err, res] = await ActivityService.getPlanList()
      if (!err && res && res.code === 0 && res.data) {
        this.planDataList = res.data
      }
    },
    // 提前获取模型code对应的item
    async getCodeByItem() {
      this.modelLoaded = false
      this.processCodeByItem = {}
      // 获取所有节点缓存
      const genrateCachedItemsByCodeNum = await this.player.Native.ModelTree.genrateCachedItemsByCode()

      for (let i = 0; i < Math.ceil(genrateCachedItemsByCodeNum / 1000); i += 1) {
        // 分页获取节点和位号
        // eslint-disable-next-line no-await-in-loop
        const res = await this.player.Native.ModelTree.getCachedItems(1000, i)
        if (_.isEmpty(res)) break
        Object.assign(this.processCodeByItem, res)
      }
      this.modelLoaded = true
    },
    // 查看日期
    handleCheck() {
      if (this.handleCheckLoadingTimer) {
        clearInterval(this.handleCheckLoadingTimer)
      }
      this.isPlaying = false
      clearInterval(this.mainTimer)
      this.handleCheckLoadingTimer = setInterval(() => {
        const dayList = _.map(this.currentUseModels, (item) => {
          return moment(item.currentDate).format('YYYY-MM-DD')
        })
        const diff = moment(this.filterPlan.checkDate).diff(
          moment(this.filterPlan.dateRange[0]),
          'day'
        )
        const checkDateIndex = _.indexOf(
          dayList,
          moment(this.filterPlan.checkDate).format('YYYY-MM-DD')
        )
        const isCorrect = checkDateIndex > -1 && checkDateIndex === diff
        if (isCorrect) {
          clearInterval(this.handleCheckLoadingTimer)
          this.sliderLoading = false
          const distanceTime = dayList.indexOf(
            moment(this.filterPlan.checkDate).format('YYYY-MM-DD')
          )
          const toTodayData = _.slice(this.includesListData, 0, this.currentTiming)
          setTimeout(() => {
            this.currentTiming = distanceTime
            this.sliderData = this.currentTiming
            this.currentProcess = this.currentUseModels[this.currentTiming]
            this.currentHighLightData = {
              data: toTodayData,
              day: this.currentTiming,
            }
          }, 1000)
        } else {
          this.sliderLoading = true
        }
      }, 200)
    },
    // 切换计划
    changePlan(val) {
      this.$set(this.filterPlan.dateRange, 0, JSON.parse(val).planStartDate)
      this.$set(this.filterPlan.dateRange, 1, JSON.parse(val).planFinishDate)
      this.planStartDate = JSON.parse(val).planStartDate
      this.planFinishDate = JSON.parse(val).planFinishDate
      this.showProcess = true
      this.sliderLoading = true
      this.handleChangePlan()
    },
    // 获取计划数据
    handleChangePlan() {
      this.currentUseModels = []
      if (
        this.progressId &&
        this.filterPlan.dateRange[0] &&
        this.filterPlan.dateRange[1] &&
        moment(this.filterPlan.dateRange[0]).isBefore(this.filterPlan.dateRange[1])
      ) {
        this.stopPlay()
        this.initProcess()
      } else {
        this.$message({
          message: '请确认选择的数据是否有效！',
          type: 'warning',
        })
      }
    },
    // 获取数据
    initProcess() {
      if (
        this.progressId &&
        this.filterPlan.dateRange[0] &&
        this.filterPlan.dateRange[1] &&
        moment(this.filterPlan.dateRange[0]).isBefore(this.filterPlan.dateRange[1])
      ) {
        const currentProcess = _.find(this.planModelInfo, ['id', JSON.parse(this.progressId).id])
        if (_.isNil(currentProcess)) {
          const momentStart = this.filterPlan.dateRange[0]
            ? moment(this.filterPlan.dateRange[0])
            : moment()
          const momentFinish = this.filterPlan.dateRange[1]
            ? moment(this.filterPlan.dateRange[1])
            : moment()
          const diff = momentFinish.diff(momentStart, 'days')
          const diffArray = [...Array(diff).keys()]
          const datePoint = _.filter(diffArray, (i) => {
            return _.isInteger(i / 30)
          })
          if (_.last(datePoint) !== _.last(diffArray)) {
            datePoint.push(_.last(diffArray))
          }
          let modelRes = []
          let currentModels = []
          let includesListData = []
          const fullShowNum = []
          _.times(datePoint.length > 1 ? datePoint.length - 1 : 1, async (index) => {
            const params = {
              processId: ' ',
              activityId: JSON.parse(this.progressId).id,
              startTime: (datePoint.length > 1
                ? moment(this.filterPlan.dateRange[0]).add(datePoint[index], 'days')
                : moment(this.filterPlan.dateRange[0])
              ).format('YYYY-MM-DD'),
              finishDate: (datePoint.length > 1
                ? moment(this.filterPlan.dateRange[0]).add(datePoint[index + 1] - 1, 'days')
                : moment(this.filterPlan.dateRange[1])
              ).format('YYYY-MM-DD'),
            }

            params.actualStartDate = moment(this.filterPlan.dateRange[0]).format('YYYY-MM-DD')
            params.actualEndDate = moment(this.filterPlan.dateRange[1]).format('YYYY-MM-DD')
            if (
              index === datePoint.length - 2 &&
              moment(this.filterPlan.dateRange[1]).diff(
                moment(this.filterPlan.dateRange[0]).add(datePoint[index + 1] - 1, 'days'),
                'days'
              ) > 0
            ) {
              params.finishDate = moment(this.filterPlan.dateRange[1]).format('YYYY-MM-DD')
            }
            const [err, res] = await ActivityService.getActivityModel(params)

            if (!err && res && res.data && res.success) {
              if (res.data.oldData && res.data.newData) {
                modelRes = _.uniqBy([...currentModels, ...res.data.oldData], 'currentDate')
                // 依据时间排序
                currentModels = _.orderBy(modelRes, ['currentDate'], ['asc'])
                // 筛选只含有List的数据
                includesListData = _.map(currentModels, (el) => {
                  // 选择所有key是List结尾的对象
                  el = _.pickBy(el, (v, k) => {
                    return _.endsWith(k, 'List')
                  })
                  // 将key的'List'去掉
                  return _.mapKeys(el, (v, k) => {
                    return k.replace('List', '')
                  })
                })
                res.data.newData.forEach((item) => {
                  fullShowNum.push(item)
                })
                this.currentUseModels = currentModels
                this.includesListData = includesListData
                this.showNum = fullShowNum
                if (
                  !_.isEmpty(this.currentUseModels) &&
                  moment(this.currentUseModels[0].currentDate).format('YYYY-MM-DD') ===
                    moment(this.filterPlan.dateRange[0]).format('YYYY-MM-DD') &&
                  _.isNil(this.handleCheckLoadingTimer) &&
                  _.isNil(this.sliderLoadingTimer)
                ) {
                  this.sliderLoading = false
                }
                if (currentModels.length >= this.sliderMaxLenngth) {
                  this.planModelInfo.push({
                    id: JSON.parse(this.progressId).id,
                    modelRes,
                    currentUseModels: currentModels,
                    includesListData,
                    showNum: fullShowNum,
                  })
                }
              }
            }
          })
        } else {
          this.sliderLoading = false
          // 总的计划开始时间与结束时间间隔天数
          const planDays = moment(this.planFinishDate).diff(moment(this.planStartDate), 'day') + 1
          // 实际选择的开始时间与总计划开始时间间隔天数
          const sliceStart = moment(this.filterPlan.dateRange[0]).diff(this.planStartDate, 'day')
          // 实际选择的结束时间与总计划结束时间间隔天数
          const sliceEnd =
            planDays - moment(this.planFinishDate).diff(this.filterPlan.dateRange[1], 'day')
          // sliceStart~sliceEnd即实际选择的时间范围内的数据
          this.currentUseModels = _.slice(currentProcess.currentUseModels, sliceStart, sliceEnd)
          this.includesListData = _.slice(currentProcess.includesListData, sliceStart, sliceEnd)
          this.showNum = currentProcess.showNum
        }
      }
    },
    // 减速
    minusSpeed() {
      this.currentSpeed = this.currentSpeed - 1
      if (this.currentSpeed < 0) {
        this.currentSpeed = 0
      }
    },
    // 加速
    addSpeed() {
      this.currentSpeed = this.currentSpeed + 1
      if (this.currentSpeed > 2) {
        this.currentSpeed = 2
      }
    },
    // 开始播放
    async btnPlay() {
      if (_.isEmpty(this.processCodeByItem)) {
        this.btnLoading = true
        await this.getCodeByItem()
        return
      }
      if (!this.isPlaying) {
        if (!this.modelLoaded) {
          this.btnLoading = true
          return
        }
        if (this.sliderLoading) {
          return
        }
        this.btnLoading = false
        this.isPlaying = true
        const toTodayData = _.slice(this.includesListData, 0, this.currentTiming)

        // const { CancelToken } = axios
        if (
          this.currentTiming + this.speedModes[this.currentSpeed] <=
          this.currentUseModels.length + 1
        ) {
          this.mainTimer = setInterval(() => {
            this.currentTiming = this.currentTiming + this.speedModes[this.currentSpeed]
            this.sliderData = this.currentTiming
            this.currentProcess = this.currentUseModels[this.currentTiming - 1]
          }, 1000)
        } else {
          this.currentProcess = _.last(this.currentUseModels)
          this.currentTiming = this.currentUseModels.length
          this.sliderData = this.currentUseModels.length
        }
      } else {
        this.isPlaying = false
        clearInterval(this.mainTimer)
      }
    },
    // 停止播放
    stopPlay() {
      this.sliderData = 0
      this.currentTiming = 0
      this.isPlaying = false
      this.currentProcess = _.isEmpty(this.currentUseModels) ? {} : this.currentUseModels[0]
      clearInterval(this.mainTimer)
      if (this.sliderLoadingTimer) {
        clearInterval(this.sliderLoadingTimer)
        this.sliderLoadingTimer = null
      }
      if (this.handleCheckLoadingTimer) {
        clearInterval(this.handleCheckLoadingTimer)
        this.handleCheckLoadingTimer = null
      }
    },
    // 进度条滑动
    sliderChanged(val) {
      if (this.sliderLoadingTimer) {
        clearInterval(this.sliderLoadingTimer)
      }
      this.isPlaying = false
      this.sliderData = val
      clearInterval(this.mainTimer)
      const currentDay = moment(this.filterPlan.dateRange[0])
        .add(val - 1, 'day')
        .format('YYYY-MM-DD')
      this.sliderLoadingTimer = setInterval(() => {
        if (_.isEmpty(this.currentUseModels)) {
          this.sliderLoading = true
          return
        }
        const dateTimeList = _.map(this.currentUseModels, (item) => {
          return moment(item.currentDate).format('YYYY-MM-DD')
        })
        const dayIndex = _.indexOf(dateTimeList, currentDay)
        const isCorrect = dayIndex > -1 && dayIndex === val - 1
        if (isCorrect) {
          this.sliderLoading = false
          this.currentTiming = val
          this.currentProcess = this.currentUseModels[val - 1]
          clearInterval(this.sliderLoadingTimer)
        } else {
          this.sliderLoading = true
        }
      }, 200)
    },
  },
}
</script>

<style lang="scss"></style>
<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
.circle-point {
  width: 12px;
  height: 12px;
  border-radius: 6px;
}
</style>
